// NOTE:
// DSGページ遷移が遅い場合にローダーを表示するために、
// onRouteUpdateDelayedとonRouteUpdateを使用して、
// カスタムイベントを発火させる。
// これらのイベントは、src/layouts/index.tsxのLoadingIndicatorコンポーネントでリッスンされている。

import type { GatsbyBrowser } from 'gatsby';

export { wrapRootElement } from './gatsby/wrap-root-element';

export const onRouteUpdateDelayed: GatsbyBrowser['onRouteUpdateDelayed'] =
  () => {
    window.dispatchEvent(new CustomEvent('routeUpdateDelayed'));
  };

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  window.dispatchEvent(new CustomEvent('routeUpdateComplete'));
};
